export const VISIT_SLOTS: { value: string; label: string }[] = [
  { value: "10:00", label: "10–11 AM" }, { value: "11:00", label: "11 AM–12 PM" }, { value: "12:00", label: "12–1 PM" },
  { value: "13:00", label: "1–2 PM" }, { value: "14:00", label: "2–3 PM" }, { value: "15:00", label: "3–4 PM" },
  { value: "16:00", label: "4–5 PM" }, { value: "17:00", label: "5–6 PM" }, { value: "18:00", label: "6–7 PM" },
];

export const slotLabel = (s: string) => VISIT_SLOTS.find((x) => x.value === s)?.label || s;

export const visitWhen = (v: { date: string; slot: string }) =>
  `${new Date(`${v.date}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" })} · ${slotLabel(v.slot)}`;

export const VISIT_CLS: Record<string, string> = {
  pending: "bg-amber-50 text-amber-800 border-amber-200", confirmed: "bg-green-50 text-green-700 border-green-200",
  declined: "bg-rose-50 text-rose-700 border-rose-200", cancelled: "bg-slate-50 text-slate-500 border-slate-200",
  done: "bg-slate-100 text-slate-600 border-slate-200",
};
